import { Typography } from "@mui/material";

import { InfoTooltip } from "../../../../Components/InfoTooltip/InfoTooltip";
import { useCurrentMonthCloudSpend } from "../../../Customer/db";
import { useFlexsaveSavings, useSpotScalingSavings } from "../30dayshooks";
import { LoadingCard } from "../LoadingCard";
import { TopCard } from "../TopCard";

export const LastMonthSavingsCard = () => {
  const spotScaling = useSpotScalingSavings();
  const flexsave = useFlexsaveSavings();

  const totalCurrentMonthSavings = spotScaling.currentMonthSavings + flexsave.currentMonthSavings;

  const loading = spotScaling.loading || flexsave.loading;

  const hasFlexsave = flexsave.currentMonthSavings > 0;
  const hasSpotScaling = spotScaling.currentMonthSavings > 0;

  const { number: currentSpend } = useCurrentMonthCloudSpend();

  if (loading) {
    return <LoadingCard title="Current month savings" />;
  }

  const ratio = currentSpend > 0 ? (totalCurrentMonthSavings / currentSpend) * 100 : 0;
  const trendStr =
    ratio > 0
      ? `${Number.isInteger(ratio) ? Math.abs(ratio) : Math.abs(ratio).toFixed(2)}% of your current month spend`
      : "";

  const title = (
    <Typography variant="h4" color="text.primary" lineHeight={1.35}>
      Current month savings
    </Typography>
  );

  const description = `Your current month's savings come from ${hasFlexsave ? "Flexsave for Compute" : ""} ${
    hasFlexsave && hasSpotScaling ? "and" : ""
  } ${hasSpotScaling ? "Spot Scaling" : ""}`;

  const titleWithTooltip =
    hasFlexsave || hasSpotScaling ? (
      <InfoTooltip description={description} cursor="default">
        {title}
      </InfoTooltip>
    ) : (
      title
    );

  const items: {
    title: string;
    path: string;
    eventName: string;
    description: string;
  }[] = [];

  const hasNoSavings = !hasFlexsave && !hasSpotScaling;

  if (hasNoSavings) {
    items.push({
      title: "Explore PerfectScale",
      path: "./optimize/perfectscale",
      eventName: "Explore PerfectScale",
      description: "Explore PerfectScale dashboard",
    });
  }

  if (spotScaling.currentMonthSavings > 0 || hasNoSavings) {
    items.push({
      title: hasNoSavings ? "Explore Spot Scaling" : "View Spot Scaling savings",
      path: "./optimize/spot-scaling",
      eventName: "View spot scaling",
      description: "View spot scaling dashboard",
    });
  }

  if (flexsave.currentMonthSavings > 0 || hasNoSavings) {
    items.push({
      title: hasNoSavings ? "Explore Flexsave for Compute" : "View Flexsave for Compute savings",
      path: "./optimize/flexsave-compute",
      eventName: "View Flexsave",
      description: "View Flexsave dashboard and savings",
    });
  }

  const subtitle = hasNoSavings ? (
    <Typography variant="caption" color="text.secondary">
      No savings at the moment
    </Typography>
  ) : (
    ""
  );

  return (
    <TopCard
      title={titleWithTooltip}
      value={totalCurrentMonthSavings}
      trend={trendStr}
      trendColor="success.main"
      items={items}
      buttonText={hasNoSavings ? "Explore our savings features" : "Review savings"}
      subtitle={subtitle}
    />
  );
};
